import PTZ from './PTZ';

export default PTZ;
export * from './types';
export * from './styles';

export { PTZ };
